import domReady from '@wordpress/dom-ready';

domReady(() => {
	const videoControl = document.querySelectorAll(
		'.media-5050__video-control'
	);
	if (videoControl) {
		videoControl.forEach((control) => {
			control.addEventListener('click', (e) => {
				const currentVideo = e.target
					.closest('.media-5050__content')
					.querySelector('video');
				playPause(currentVideo);
				if (e.target.textContent === 'Pause Video') {
					e.target.textContent = 'Play Video';
					e.target.classList.add('media-5050__video-control--paused');
				} else {
					e.target.textContent = 'Pause Video';
					e.target.classList.remove(
						'media-5050__video-control--paused'
					);
				}
			});

			function playPause(myVideo) {
				if (myVideo.paused) {
					myVideo.play();
				} else {
					myVideo.pause();
				}
			}
		});
	}
});
